<template>
    <div class="pdfdiv">
        <canvas :id =id_num v-bind="canvasAttrs"></canvas>
    </div>
</template>

<script>
export default {
  name: 'PdfPage',
  props: {
    page: {
      type: Object, // instance of PDFPageProxy returned from pdf.getPage
      required: true,
    },
    scale: {
      type: Number,
      required: true,
    },
    id_num: {
      type: Number,
      required: true,
    }
  },
  data () {
    return {
      viewport: undefined
    }
  },
  created() {
    // PDFPageProxy#getViewport
    // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
    console.log("pdfpage created");
    this.viewport = this.page.getViewport({scale:this.scale});
    console.log("pdfpage created"+ this.scale);
  },

  computed: {
    canvasAttrs() {
      let {width, height} = this.viewport;
      [width, height] = [width, height].map(dim => Math.ceil(dim));

      const style = this.canvasStyle;

      return {
        width,
        height,
        style,
        class: 'pdf-page',
      };
    },

    canvasStyle() {
      const {width: actualSizeWidth, height: actualSizeHeight} = this.actualSizeViewport;
      const pixelRatio = window.devicePixelRatio || 1;
      const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight]
        .map(dim => Math.ceil(dim / pixelRatio));
      return `width: ${pixelWidth}px; height: ${pixelHeight}px;`
    },

    actualSizeViewport() {
      return this.viewport.clone({scale: this.scale});
    },
  },
  methods: {
    /*prin(id){
        console.log(id);
        
    
    }*/
    drawPage(){
        console.log(this.viewport);
        var viewport = this.viewport;
        console.log("mounted in pdfpage");
        // Prepare canvas using PDF page dimensions
        const canvas = document.getElementById(this.id_num);
        //canvas.width = viewport.width

        //console.log("mounted in pdfpage"+viewport.height);
        // Render PDF page into canvas context
        const canvasContext = canvas.getContext('2d');
        const renderContext = { canvasContext, viewport }
        this.page.render(renderContext).promise.then(function() {
            var height = canvasContext.canvas.height - 50;
            canvasContext.font = "20px Georgia";
            canvasContext.fillText("UserID: 201912", 120, height);
        })
    }
  },
  watch: {
    scale: function () {
        console.log("scale");
        this.viewport = this.page.getViewport(this.scale);
        console.log("scale"+this.scale);
        this.drawPage();
    }
  },
  mounted(){
    
    this.drawPage();
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pdfdiv{
    width: 100%;
    background: gray;
}

</style>
